import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getPathWithQueryString, pageContext, appendQueryString, logMessage } from 'ctm-util-functions';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { MechaButton } from 'ctm-components/components/mecha_components/mecha_button/mecha_button';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mechaColours } from 'ctm-components/components/mecha_components/mecha_styles';
import { tokensSelector } from 'ctm-selectors';
import { updateState } from 'ctm-components/components/prefill/utils';
import { useStyles } from './summary_table_styles';
import { getAssetFilePath } from '../products/summary/common/get_asset_file_path';
import {reporterLog} from "ctm-app/client/sagas/reporter";

const _SummaryTable = (props) => {
    const {
        titleLabel,
        tableContent,
        isUpdated,
        path,
        userAccessToken,
        currentPage,
        journeyId,
        isEditableFlag,
        journeyBaseUrl,
        stageChange,
        mapToState,
        stageChangeIsEditable,
        serverConfigEnv,
        setOptInPrivacy,
        snapshotState,
        coverDetail,
        applicant,
        showApiActionError,
        verifyBucket
    } = props;
    const isXs = pageContext.getProps().pageState.breakpoint === 'xs';
    const classes = useStyles({ isUpdated, isXs });
    const finalRow = tableContent.length - 1;

    const handleClick = async () => {
        let counter = 0;
        counter += 1;

        if (!isEditableFlag) {
            logMessage('TestFlag#Firstclick counter:', counter);
            const cloneEndpoint = `${journeyBaseUrl}${serverConfigEnv === 'local' ? '' : '/'}journey/${journeyId}/clone`;

            await fetch(cloneEndpoint, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userAccessToken}`,
                    'Content-Type': 'application/json'
                    // Add any additional headers if needed
                }
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    } else {
                        showApiActionError(false);
                        return response.json(); // assuming the response is JSON
                    }
                })
                .then((data) => {
                    snapshotState(coverDetail, applicant);
                    if (!isEditableFlag && currentPage === 'confirmation') {
                        if (data.cloneFrom && data.isEditable) {
                            stageChange(data.cloneFrom);
                            stageChangeIsEditable(data.isEditable);
                            mapToState(data);
                            logMessage('state mapping Successful');
                            logMessage('Added in form summaryPageEdit', path);
                            logMessage('GTM EVENT successful');
                            setOptInPrivacy();
                        }
                    }
                })
                .catch((err) => {
                    reporterLog('Clone endpoint request failed', err);
                    showApiActionError(true);
                });
        }
        pageContext.getProps().browserHistory.push(appendQueryString(getPathWithQueryString(`/car-insurance/journey/${path}`), 'isEdit=true'));
    };

    return (
        <div className={classes.summary_table_wrapper} data-id={`summarySection${titleLabel.replace(/ /g, '')}`}>
            <div className={`${verifyBucket ? classes.summary_title_verify_wrapper : classes.summary_title_wrapper}`}>
                <div className={classes.title}>
                    {isUpdated ? <FontAwesomeIcon className={classes.checkIcon} icon={faCheckCircle} color={mechaColours.primary500} /> : null}
                    {titleLabel}
                </div>
                {tableContent.some((item) => item?.userToVerify)
                    ? (
                        <MechaButton
                            id={`summaryEditButton${titleLabel.replace(/ /g, '')}`}
                            data-id={`summaryEditButton${titleLabel.replace(/ /g, '')}`}
                            buttonLabel="Update details"
                            buttonSize="xs"
                            buttonType="primary"
                            trackingLabel={`Edit for ${titleLabel}`}
                            color="blue"
                            onClick={handleClick}
                            icon={{ icon: faPen, color: '#FFFFFF', fixedWidth: '1.4rem' }}
                        />
                    ) : (
                        <button
                            type="button"
                            className={classes.edit_button}
                            id={`summaryEditButton${titleLabel.replace(/ /g, '')}`}
                            data-id={`summaryEditButton${titleLabel.replace(/ /g, '')}`}
                            // eslint-disable-next-line react/no-unknown-property
                            trackingLabel={`Edit for ${titleLabel}`}
                            onClick={handleClick}
                        >
                            <FontAwesomeIcon icon={faPen} color={mechaColours.primary500} fixedWidth={'1.4rem'} />
                            <p>Edit</p>
                        </button>
                    )}

            </div>
            {tableContent.map((object, i) => {
                // Final row will have both classes
                return (
                    <div
                        key={object?.title}
                        className={`${i === finalRow ? classes.summary_body_row_final : null} ${classes.summary_body_row} ${
                            object?.userToVerify ? classes.summary_body_row_verify : ''
                        }`}
                        data-id={`summaryRow${object?.title.replace(/ /g, '')}`}
                    >
                        <div className={classes.row_title}>{object?.title + (object?.title !== 'None' ? ':' : '')}</div>
                        <div className={classes.row_container}>
                            <p className={classes.row_value}>{object?.value}</p>
                            {object?.userToVerify && (
                                <img src={getAssetFilePath('/assets/brand/ctm/images/RequiredQuestionMark.svg')}
                                    alt="required-question-mark"
                                    className={classes.required_question_mark} />
                            )}
                        </div>

                    </div>
                );
            })}
        </div>
    );
};

_SummaryTable.propTypes = {
    titleLabel: PropTypes.string,
    path: PropTypes.string,
    tableContent: PropTypes.array,
    isUpdated: PropTypes.bool
};

const mapDispatchToProps = (dispatch) => ({
    showApiActionError: (value) => {
        dispatch({
            type: 'SET_PAGE_VALUE',
            value,
            identifier: 'displayErrorPageWithNewQuoteButton'
        });
    },
    stageChange: (cloneInfo) => {
        dispatch({
            type: 'SET_VALUE',
            value: cloneInfo,
            stateKey: 'vertical.quote',
            identifier: 'cloneFrom'
        });
    },
    setVerifiedAnswers: (value) => {
        dispatch({
            type: 'SET_VALUE',
            value,
            stateKey: 'vertical.quote',
            identifier: 'verifiedAnswers'
        });
    },
    stageChangeIsEditable: (isEditable) => {
        dispatch({ type: 'SET_VALUE', value: isEditable, stateKey: 'vertical.quote', identifier: 'isEditable' });
        dispatch({ type: 'ELEVEN_MONTH_QUOTE_START' });
    },
    mapToState: (responsePayload) => {
        updateState(dispatch, responsePayload);
    },
    setOptInPrivacy: () => {
        dispatch({
            type: 'SET_FORM_VALUE',
            value: 'Y',
            stateKey: 'vertical.quote',
            identifier: 'applicant.optInPrivacy',
            sendTouch: true
        });
    },
    snapshotState: (coverDetail, applicant) => {
        // these properties are used to identify if a user has updated a data bucket on the confirmation page
        // if they have a tick is displayed indicated the bucket has been updated
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: 'snapshotCoverDetail',
            value: coverDetail
        });
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: 'snapshotApplicant',
            value: applicant
        });
    }
});

const mapStateToProps = (state) => {
    const isEditableFlag = state.getIn(['vertical', 'quote', 'form', 'isEditable']);
    const userAccessToken = tokensSelector(state).get('access_token');
    const currentPage = state.getIn(['page', 'name']);
    const journeyId = state.getIn(['user', 'journey', 'transaction', 'journeyId']);
    const journeyBaseUrl = state.getIn(['serverConfig', 'journeyServiceBaseUrl']);
    const serverConfigEnv = state.getIn(['serverConfig', 'env']);
    const coverDetail = state.getIn(['vertical', 'quote', 'form', 'coverDetail']);
    const applicant = state.getIn(['vertical', 'quote', 'form', 'applicant']);
    return { userAccessToken, currentPage, journeyId, journeyBaseUrl, isEditableFlag, serverConfigEnv, coverDetail, applicant };
};

const SummaryTable = connect(
    mapStateToProps,
    mapDispatchToProps
)(_SummaryTable);

export { _SummaryTable, SummaryTable };
